import React, { useEffect, useState } from 'react'
import OwlCarousel from 'react-owl-carousel';
import AOS from "aos";
import "aos/dist/aos.css";
import { useDispatch, useSelector } from 'react-redux'
import { getHomeTutorViewData, getPopularTutorsData } from '../../../Redux/action/MasterAction';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import Aos from 'aos';
import SkeletonLoaderPopularTutor from '../../../Common/skeleton/PopularTutors/SkeletonLoaderPopularTutor';
import { Modal } from 'react-bootstrap';
import Beatloader from '../../../Common/BeatLoader';


const host = process.env.REACT_APP_API_SERVER
const PopularMentor = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getPopularTutorsData())
    }, []);

    const {

        loadingHomeTutorViewDataListApi,
        HomeTutorViewDataListApiData,
        HomeTutorViewDataListApiError,

        loadingPopularTutorDataListApi,
        PopularTutorDataListApiData,
        PopularTutorDataListApiError,
    } = useSelector(state => state?.MasterReducer);


    const [showModal, setShowModal] = useState(false);

    const handleModalClick = (id) => {
        setShowModal(true)
        dispatch(getHomeTutorViewData(id))
    }

    const tutorCount = PopularTutorDataListApiData?.length || 0;

    const options = {
        loop: tutorCount > 2,
        rewind: tutorCount <= 2,
        margin: 15,
        nav: true,
        dots: false,
        autoplay: tutorCount > 2,
        autoplayTimeout: 2500,
        autoplayHoverPause: true,
        smartSpeed: 600,
        responsive: {
            0: { items: 1.1 },
            359: { items: 1.08},
            435: { items: 1.069 },
            576: { items: 1.055 },
            600: { items: 2.08 },
            1000: { items: 4.048 }
        }
    };


    const navigate = useNavigate();
    const handleNavigation = () => {
        const token = localStorage.getItem('student-token')
        if (token) {
            const decoded = jwtDecode(token);

            if (decoded?.user?.id) {
                navigate('/student/dashboard')
            }
            else {
                navigate('/login', { state: { user: 'student' } })
            }
        }
        else {
            navigate('/login', { state: { user: 'student' } })
        }

    }

    useEffect(function () {
        Aos.init({ duration: 1000 });
    }, []);

    if (loadingPopularTutorDataListApi) {
        return <SkeletonLoaderPopularTutor />;
    }

    return (
        <>
            <section className="popular-mentor">
                <div className="mentor-wrapper" data-aos="fade-up">
                    <div
                        className="heading"

                        style={{ marginTop: "3rem", marginBottom: 0 }}
                    >

                        <span className="ruby section-badge">
                            POPULAR TUTOR
                        </span>

                    </div>
                    {/* <div className="popular-three-head">
                        <div
                            className="section-header h-three"

                        >
                            <div className="heading-bar"></div>
                        </div>
                    </div> */}
                    <OwlCarousel
                        className="owl-theme section"
                        margin={20}
                        {...options}

                    >

                        {PopularTutorDataListApiData?.map((data) => (
                            // <div className="card" key={data?.id}>
                            //     <img
                            //         className="card-img-top"
                            //         src={`${host}${data?.tutor?.profile_img}`}
                            //         alt="Card image"
                            //         style={{ width: "100%", height: "250px" }}
                            //         onError={(e) => {
                            //             e.target.src = '/assets/img/user/avatar1.jpg'; // Fallback image
                            //         }}
                            //     />
                            //     <div className="card-body" >
                            //         <div style={{ height: '200px', overflow: 'auto' }}>
                            //             <h4 className="card-title">{data?.tutor?.name}</h4>
                            //             <h5>{data?.tutor?.tutordetails?.specialization ? (data?.tutor?.tutordetails?.specialization).toUpperCase() : ''}</h5>
                            //             <p className="card-text line-clamp">
                            //                 {" "}
                            //                 {data?.tutor?.tutordetails?.about_the_tutor}
                            //             </p>
                            //         </div>
                            //         <a onClick={() => { handleModalClick(data?.tutor?.id); }} className="btn btn-primary see-profile">
                            //             See Profile
                            //         </a>
                            //     </div>
                            // </div>

                            <div className="mentor-card" key={data?.id}>
                                <div className="mentor-image">
                                    <img
                                        src={`${host}${data?.tutor?.profile_img}`}
                                        alt="mentor"
                                        onError={(e) => {
                                            e.target.src = '/assets/img/user/avatar1.jpg';
                                        }}
                                    />
                                </div>

                                <div className="mentor-content">
                                    <h4 className="mentor-name">
                                        {data?.tutor?.name}
                                    </h4>

                                    <div className="mentor-specialization">
                                        {data?.tutor?.tutordetails?.specialization &&
                                            data.tutor.tutordetails.specialization
                                                .split(",")
                                                .map((item, index) => (
                                                    <span key={index} className="mentor-badge">
                                                        {item.trim()}
                                                    </span>
                                                ))}
                                    </div>
                                    <p className="mentor-about line-clamp">
                                        {data?.tutor?.tutordetails?.about_the_tutor}
                                    </p>

                                    <button
                                        onClick={() => handleModalClick(data?.tutor?.id)}
                                        className="mentor-btn"
                                    >
                                        See Profile
                                    </button>
                                </div>
                            </div>
                        ))}

                        {/* Repeat more cards */}
                    </OwlCarousel>
                </div>
            </section>

            <>

                {/* Tutor Details Modal */}
                <Modal show={showModal}
                    onHide={() => setShowModal(false)} style={{ zIndex: '10000' }}>

                    {loadingHomeTutorViewDataListApi ?
                        <Beatloader /> :
                        <div className="modal-content" >
                            <Modal.Header closeButton>
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Tutor Details
                                </h5>

                            </Modal.Header>
                            <div className="modal-body">
                                <div className="row mb-2">
                                    <div className="col-lg-4">
                                        <img
                                            onError={(e) => {
                                                e.target.src = '/assets/img/user/user.png'; // Fallback image
                                            }}
                                            src={`${host}${HomeTutorViewDataListApiData?.image}`}
                                            className="img-fluid"
                                            style={{ height: "7.6rem", width: "auto" }}
                                        />
                                    </div>
                                    <div className="col-lg-8 col-md-8" style={{ width: "fit-content" }}>
                                        <h5 className="mb-0">{HomeTutorViewDataListApiData?.name}</h5>
                                        {HomeTutorViewDataListApiData?.tutordetails?.experience && <p className="mb-0">Experience: {HomeTutorViewDataListApiData?.tutordetails?.experience} Years</p>}
                                        <p className="mb-0">Ratings</p>
                                        <div className="rating">
                                            {Array.from({ length: 5 }, (_, index) => {
                                                const averageRating = parseFloat(HomeTutorViewDataListApiData?.avarageRating || "0"); // Convert to number
                                                if (index < Math.floor(averageRating)) {
                                                    return <i key={index} className="fas fa-star filled ms-1" />;
                                                } else if (index < averageRating) {
                                                    return <i key={index} className="fas fa-star-half-alt filled ms-1" />;
                                                } else {
                                                    return <i key={index} className="fas fa-star ms-1" />;
                                                }
                                            })}

                                            <span className='ms-1'>
                                                {HomeTutorViewDataListApiData?.avarageRating} <span className="text-primary">({HomeTutorViewDataListApiData?.reviewCount} Ratings)</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {HomeTutorViewDataListApiData?.tutorteachingdetails?.length > 0 &&
                                    <div className="row mt-3">
                                        <div className="col-lg-12 mb-2">
                                            <p className="mb-0">Subject</p>
                                            <h6>
                                                {[...new Set(HomeTutorViewDataListApiData?.tutorteachingdetails?.map(data => data?.sub_category?.name))]
                                                    .filter(Boolean) // Remove null or undefined values
                                                    .map((name, index, uniqueNames) => (
                                                        <span key={index}>
                                                            {name}
                                                            {index !== uniqueNames.length - 1 && ", "}
                                                        </span>
                                                    ))}

                                            </h6>

                                        </div>
                                    </div>}
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <p className="mb-0">Tutoring</p>
                                    </div>
                                    <div className="col-lg-10">
                                        <h6>One to One</h6>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>${HomeTutorViewDataListApiData?.tutordetails?.per_session_price_one_to_one}</p>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <p className="mb-0">Group Tutoring</p>
                                    </div>
                                    <div className="col-lg-10">
                                        <h6>Group Class</h6>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>${HomeTutorViewDataListApiData?.tutordetails?.per_session_price_group}</p>
                                    </div>
                                </div>
                                <div></div>
                            </div>

                        </div>}

                </Modal>
            </>
        </>
    )
}

export default PopularMentor